<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Bloqueados</p>
      <h1 class="text-2xl font-semibold leading-tight">Gerencie números bloqueados</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Mantenha a lista de bloqueio organizada. Adicione, pesquise ou libere números com poucos cliques.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Total</p>
        <strong class="text-lg">{{ totalRegistros || 0 }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Página</p>
        <strong class="text-lg">{{ pageInfo.currentPage }} / {{ pageInfo.totalPages || 1 }}</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-3 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <label class="flex items-center gap-2 rounded-base border border-border-color bg-light-color px-3 py-2 text-sm text-dark-color" for="filtro-bloqueado">
        <mat-icon>search</mat-icon>
        <input
          id="filtro-bloqueado"
          aria-label="Buscar número bloqueado"
          class="w-full bg-transparent outline-none"
          type="search"
          placeholder="Buscar número"
          [(ngModel)]="filterNumber"
          (ngModelChange)="onFilterChange()" />
      </label>
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover"
        (click)="openModalRegistroBloqueado()">
        <mat-icon>add</mat-icon>
        Novo número
      </button>
    </div>

    <div class="overflow-hidden rounded-xl border border-border-color">
      <table class="min-w-full divide-y divide-border-color text-sm">
        <thead class="bg-light-color/60">
          <tr>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">
              <button
                type="button"
                class="inline-flex items-center gap-1 text-left font-semibold text-dark-color"
                (click)="toggleSort()"
                aria-label="Ordenar por número">
                Número
                <mat-icon class="text-sm">{{ sortAsc ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </button>
            </th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Ações</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-border-color">
          <tr
            *ngFor="let bloqueado of currentBloqueados; trackBy: trackByIndex"
            class="hover:bg-light-color/60 transition">
            <td class="px-4 py-3 text-dark-color">{{ bloqueado.number }}</td>
            <td class="px-4 py-3 text-right">
              <button
                type="button"
                class="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                (click)="desbloquearNumero(bloqueado.number)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </tr>
          <tr *ngIf="currentBloqueados.length === 0">
            <td colspan="2" class="px-4 py-6 text-center text-dark-color/70">
              Nenhum número bloqueado encontrado.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex flex-col items-center justify-between gap-3 text-sm md:flex-row">
      <div class="flex items-center gap-2">
        <span>Registros por página:</span>
        <select
          class="rounded-base border border-border-color px-3 py-2 text-dark-color"
          aria-label="Registros por página"
          (change)="alterQuantidadeView($event)">
          <option value="5" selected>5</option>
          <option value="10">10</option>
          <option value="20">20</option>
        </select>
        <span>
          {{ startRange() }} -
          {{ endRange() }}
          de {{ totalRegistros || 0 }}
        </span>
      </div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color text-dark-color transition hover:border-primary-color hover:text-primary-color"
          [disabled]="pageInfo.currentPage === 1 || pageInfo.totalPages <= 1"
          (click)="previousPage()">
          <mat-icon>arrow_back_ios</mat-icon>
        </button>
        <span class="font-semibold">{{ pageInfo.currentPage }}</span>
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color text-dark-color transition hover:border-primary-color hover:text-primary-color"
          [disabled]="pageInfo.currentPage === pageInfo.totalPages || pageInfo.totalPages <= 1"
          (click)="nextPage()">
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
      </div>
    </div>
  </section>
</div>

<ng-container *ngIf="modalRegistroBloqueado">
  <div class="fixed inset-0 z-30 flex items-center justify-center bg-black/50 px-4">
    <div class="w-full max-w-lg rounded-xl bg-white p-6 shadow-2xl">
      <div class="flex items-center justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Cadastro</p>
          <h3 class="text-lg font-semibold text-dark-color">Novo número bloqueado</h3>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalRegistroBloqueado()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form class="mt-4 flex flex-col gap-4" (ngSubmit)="sendBloquear()" novalidate>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="numero">
          <span class="block">Número</span>
          <input
            id="numero"
            name="numero"
            type="tel"
            autocomplete="tel"
            aria-label="Número para bloquear"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            placeholder="(99) 99999-9999"
            [(ngModel)]="numero"
            (keypress)="permitirSomenteNumeros($event)"
            (input)="onNumeroInput()"
            maxlength="15"
            required />
          <small class="text-xs text-dark-color/70">Formato: (99) 99999-9999</small>
        </label>

        <div class="flex justify-end gap-2">
          <button
            type="button"
            class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color"
            (click)="closeModalRegistroBloqueado()">
            Cancelar
          </button>
          <button
            type="submit"
            class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
            Bloquear
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="modalConfirmDelete">
  <div class="fixed inset-0 z-40 flex items-center justify-center bg-black/50 px-4">
    <div class="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
      <div class="flex items-center justify-between border-b border-border-color pb-3">
        <h3 class="text-lg font-semibold text-dark-color">Confirmar desbloqueio</h3>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="cancelarDesbloqueio()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <p class="mt-4 text-sm text-dark-color">Deseja realmente desbloquear o número selecionado?</p>
      <div class="mt-4 flex justify-end gap-2">
        <button
          type="button"
          class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color"
          (click)="cancelarDesbloqueio()">
          Cancelar
        </button>
        <button
          type="button"
          class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover"
          (click)="confirmarDesbloqueio()">
          Desbloquear
        </button>
      </div>
    </div>
  </div>
</ng-container>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
